(() => {
  const hdr = document.querySelector('.hdr');
  if (hdr) {
    const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }
  document.querySelectorAll('details.drawer').forEach(d => {
    d.addEventListener('toggle', () => {
      const h = d.closest('.hdr');
      if (h) document.documentElement.style.setProperty('--drawer-top', h.getBoundingClientRect().bottom + 'px');
      document.body.style.overflow = d.open ? 'hidden' : '';
    });
    d.addEventListener('keydown', e => { if (e.key === 'Escape') { d.open = false; } });
  });
  document.querySelectorAll('[data-announce]').forEach(bar => {
    const msgs = bar.querySelectorAll('.announce__msg');
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    if (msgs.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => { msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false; }, speed);
  });
})();
